/**
 * @snippet AppShell
 * @description Workspace orchestrator — slots for sidebar, header,
 *   page content, and footer.
 *
 *   Background colours intentionally split: the sidebar provides its
 *   own white surface, while the main content area sits on a very
 *   light off-white (var(--moksy-canvas)) so cards (pure white) get gentle
 *   separation without needing shadows. Pages compose <PageShell>
 *   inside this for breadcrumb + title + content rhythm.
 */
export const AppShell = ({ sidebar, header, children, footer }) => (
  <div className="flex h-screen w-full overflow-hidden bg-[var(--moksy-canvas)]">
    <a href="#main-content" className="skip-link">Skip to main content</a>

    {sidebar}

    <div className="relative flex h-full min-w-0 flex-1 flex-col">
      {header}

      <main
        id="main-content"
        tabIndex="-1"
        className="flex flex-1 flex-col overflow-y-auto overflow-x-hidden bg-[var(--moksy-canvas)] focus:outline-none"
      >
        <div className="w-full max-w-[1600px] flex-1 px-4 py-5 md:px-6 md:py-6 lg:px-8">
          {children}
        </div>
        {footer}
      </main>
    </div>
  </div>
);
